<template>
  <div id="monster-lookup">
    <div class="row">

      <div class="col-md-2 col-xs-12">
        <Combat class="mb-2" :stats="monster"></Combat>
      </div>

      <div class="col-md-10 col-xs-12">
        <vue-bootstrap-typeahead
          v-model="query"
          :serializer="item => item.wiki_name"
          :data="monsters"
          @hit="monsterSelected"
          placeholder="Enter a monster"
        >

          <!-- Begin custom suggestion slot -->
          <template slot="suggestion" slot-scope="{ data, htmlText }">
            <div class="d-flex align-items-center">
                    <span class="ml-2">
                      <img loading="lazy" sizes="100%, 100%" class="img-fluid" src="/static/images/icons/combat.png">
                      {{data.combat_level}}
                    </span>
              <span class="ml-4" v-html="htmlText"></span>
              <span class="slayer-icon mr-4" v-if="data.slayer_level > 1">
                      <img loading="lazy" sizes="100%, 100%" class="img-fluid" src="/static/images/icons/slayer.png">
                      {{data.slayer_level}}
                    </span>
              <span class=" ml-2 members-icon" v-if="data.members">
            <img loading="lazy" sizes="100%, 100%" class="img-fluid" src="/static/images/icons/member.png">
          </span>
            </div>
          </template>

        </vue-bootstrap-typeahead>
      </div>
    </div>
  </div>
</template>

<script>
  import VueBootstrapTypeahead from 'vue-typeahead-bootstrap'
  import EquipmentBonus from "./gear-selector/EquipmentBonus";
  import Combat from "./stats/Combat";

  export default {
    name: "MonsterLookup",
    components: {Combat, EquipmentBonus, VueBootstrapTypeahead},
    props: {
      monster: {
        type: Object,
        default: function () {
          return null
        }
      },
    },
    data() {
      return {
        query: '',
        monsters: [],
      }
    },
    methods: {
      getSearchList: function () {
        this.$http.get('https://www.osrsbox.com/osrsbox-db/monsters-complete.json').then((resp) => {
          // console.log(result);

          this.monsters = Object.keys(resp.data).map(function (key) {
            return resp.data[key];
          });

          //Set monster name string as it would of loaded by now
          if (this.monster) {
            this.query = this.monster.wiki_name
          }
        })
      },
      monsterSelected: function (monster) {
        console.log('monster selected', monster);


        localStorage.setItem("osrs:compare:monster", JSON.stringify(monster));
        this.$emit('hit', monster)
      }
    },
    mounted() {
      this.getSearchList();
    }
  }
</script>

<style scoped>
  .slayer-icon {
    margin-left: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/MonsterLookup.vue